import { render, staticRenderFns } from "./BaseColTitle.vue?vue&type=template&id=20734be4&"
import script from "./BaseColTitle.vue?vue&type=script&lang=js&"
export * from "./BaseColTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports